import { FC } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { StandardModal, StandardModalHeader } from "@design-system/Modal/Modal";
import { useLoadStripe } from "@hooks/billing/useLoadStripe";
import { useStripeSetupModeOptions } from "@hooks/billing/useStripeSetupModeOptions";
import { AcceptOrgBillingTransferForm } from "./AcceptOrgBillingTransferForm";
import { PendingOrgBillingTransferModalProps } from "./usePendingOrgBillingTransferModal";

export const AcceptOrgBillingTransferModal: FC<
    PendingOrgBillingTransferModalProps
> = ({ request, onClose }) => {
    const stripePromise = useLoadStripe();
    const stripeOptions = useStripeSetupModeOptions();

    return (
        <StandardModal show backdrop="static" onHide={onClose}>
            <StandardModalHeader>Set up billing</StandardModalHeader>
            <Elements stripe={stripePromise} options={stripeOptions}>
                <AcceptOrgBillingTransferForm
                    request={request}
                    onClose={onClose}
                />
            </Elements>
        </StandardModal>
    );
};
